import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { Router } from '@angular/router';

@Component({
    selector: 'app-email-template-overview',
    imports: [CommonModule, DxButtonModule],
    templateUrl: './email-template-overview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./email-template-overview.component.css']
})
export class EmailTemplateOverviewComponent {

  constructor(private router: Router) { }


  goTo(path: string): void {
    this.router.navigate([path]);
  }
}
